import { BaseTracking } from "app/core/tracking/base-tracking";
import { Config } from "app/core/vo/config";

export class Disabled extends BaseTracking {
	public doInitialize(): void {
		this.notifyInitialize();
	}
}
